import { render, staticRenderFns } from "./AgencyCommissionTerms.vue?vue&type=template&id=18963ad6&scoped=true&"
import script from "./AgencyCommissionTerms.vue?vue&type=script&lang=js&"
export * from "./AgencyCommissionTerms.vue?vue&type=script&lang=js&"
import style0 from "./AgencyCommissionTerms.vue?vue&type=style&index=0&id=18963ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18963ad6",
  null
  
)

export default component.exports